import React from "react";
import { Box, Typography, List, ListItem, ListItemText } from "@mui/material";

const guidelines = [
  "I confirm that all content is legally owned by me and does not infringe on copyrights or intellectual property rights of any third-party rights and ownerships.",
  "I confirm that I have obtained all necessary clearances and permissions for music, clips or other copyrighted materials.",
  "I confirm that the content I am uploading adheres to the Platform’s content guidelines.",
  "I confirm that the content is free from any images, videos, displays, language and/or audio that is considered, directly, indirectly or by inference, offensive, pornographic, defamatory, libelous, promoting terrorism, unlawful violence and/or violates the applicable laws of the Territory/Country where the content is being published.",
  "I confirm that the content uploaded does not discredit or disrespect religious, cultural, political, ethnic, gender and/or social, sensitivities of the Country where the content is being published.",
  "I confirm that content adheres to appropriate age and content ratings.",
  "I confirm that the content uploaded is without any logo, disclaimer ticker, blur footage, image and/or banner which is not part of the content as originally produced.",
  "I confirm that I have read and agree to the platform’s terms and conditions.",
  "I confirm that the content uploaded does not discredit or disrespect religious and/or cultural sentiments of the Country where the content is being published.",
  "I confirm that all this checklist is correct and true to the best of my knowledge and beliefs, and nothing has been concealed therefrom.",
  "That I have read, understood, and agreed to the terms of this checklist and have executed this with my own free will without any force, duress and/or coercion.",
];

const ContentGuidelines = () => {
  return (
    <Box sx={{ padding: 3 }}>
      <Typography variant="h4" gutterBottom>
        Following are the Content Guidelines
      </Typography>
      <List>
        {guidelines.map((guideline, index) => (
          <ListItem key={index} disablePadding>
            <ListItemText primary={`• ${guideline}`} />
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default ContentGuidelines;
